/**
 * Company
 */
export const accountType = {
    1: "Vip 4",
    2: "Vip 3",
    3: "Vip 2",
    4: "Vip 1"
};

export const pagesInfo = {
    header: {
        home: {
            id: 0,
            title: "Dashboard information",
            name: "Home",
            route: "/home"
        },
    },
    avatarDefault: "/image/avatar-default.svg",
    footer: {},
    sideBar: {}
};
